const Endpoints = {
  base: process.env.DICOOGLE_BASE_URL || window.location.pathname.slice(1),
  search: "/search"
};
export { Endpoints };
